import React, { Component } from 'react';
import { Image, Button } from 'react-bootstrap';

class CircleButton extends Component {
    
    
    render() {
        return (
        <Button type="button" className="circleButton" href={this.props.href}>
            <Image className="icons" src={this.props.images} responsive></Image>
        </Button>
        );
    }
}

export default CircleButton;



// WEBPACK FOOTER //
// ./src/component/Util/CircleButton.js